function contar(quantidade, singular, plural) {
    if (quantidade === 0)
        return null;
    return `${quantidade} ${quantidade === 1 ? singular : plural}`;
}
/**
 * A lista que a confirmação mostra: "1 oportunidade", "o Lead", "o Contato e
 * seus dados"… Só o que existe; zero não vira linha.
 */
export function descreverExclusao(previa) {
    return [
        contar(previa.oportunidades, 'oportunidade', 'oportunidades'),
        previa.leadSaiJunto ? 'o Lead, com as respostas do formulário' : null,
        contar(previa.cadencias, 'cadência', 'cadências'),
        contar(previa.tarefas, 'tarefa', 'tarefas'),
        contar(previa.interacoes, 'interação registrada', 'interações registradas'),
        previa.contatoSaiJunto ? 'o Contato: nome, telefone, e-mail e documento' : null,
        contar(previa.documentos, 'arquivo anexado', 'arquivos anexados'),
    ].filter((linha) => linha !== null);
}
//# sourceMappingURL=exclusao.js.map